import { Duration, Instant } from "@js-joda/core";
import React from "react";
import { STRINGS } from "../../strings";
import { globalize, translate } from "../../translate";
import AnimatedModal from "../AnimatedModal";
import { AppButton } from "../Generic/AppButton";
import { default as WomanClockCoinsVector } from "/public/assets/woman-clock-coins.svg?react";

export interface PromptAdjustVisitTimesModalProps {
  isOpen: boolean;
  offset: Duration;
  adjustedEndTimeUTC: Instant;
  onSuccess: (params: { adjust: boolean }) => void;
  onRequestClose: () => void;
}

const PromptAdjustVisitTimesModal = (props: PromptAdjustVisitTimesModalProps) => {
  const visitEndTime = globalize().formatInstant(props.adjustedEndTimeUTC, { time: "short" });

  const content =
    props.offset.seconds() > 0
      ? translate(STRINGS.VISIT_TIME_ADJUSTMENT_CONTENT_LATE)
      : translate(STRINGS.VISIT_TIME_ADJUSTMENT_CONTENT_EARLY);

  const message = (
    <>
      <p>{content}</p>
      <p style={{ fontWeight: "700" }}>New end time: {visitEndTime}</p>
      <p>{translate(STRINGS.THIS_WILL_ALLOW_YOU_TO_EASILY_ACCESS_YOUR_INSTAPAY)}</p>
    </>
  );

  const actions = (
    <>
      <AppButton variant="filled" color="primary" onClick={() => props.onSuccess({ adjust: true })}>
        {translate(STRINGS.YES_ADJUST_TIMES)}
      </AppButton>

      <AppButton variant="link" color="black" onClick={() => props.onSuccess({ adjust: false })}>
        {translate(STRINGS.NO_KEEP_THE_ORIGINAL_TIMES)}
      </AppButton>
    </>
  );

  return (
    <AnimatedModal
      headline={translate(STRINGS.VISIT_TIME_ADJUSTMENT)}
      message={message}
      animation={<WomanClockCoinsVector />}
      animationOffset={100}
      actions={actions}
      isOpen={props.isOpen}
      onRequestClose={props.onRequestClose}
    />
  );
};

export default PromptAdjustVisitTimesModal;
